/**
 * Parse JSON that may contain unquoted property names.
 * Converts JavaScript object notation to valid JSON before parsing.
 * 
 * @param {string} jsonString - JSON string that may have unquoted property names
 * @returns {any} Parsed JavaScript object
 * @throws {Error} If the string cannot be parsed as JSON
 */
export function parseRelaxedJson(jsonString) {
	if (!jsonString || typeof jsonString !== 'string') {
		throw new Error('Invalid input: expected a string');
	}

	try {
		// First try standard JSON.parse
		return JSON.parse(jsonString);
	} catch (e) {
		// If that fails, try to fix unquoted property names
		try {
			// Replace unquoted property names with quoted ones
			// This regex finds property names like: propertyName: or propertyName :
			// and converts them to "propertyName":
			const fixedJson = jsonString.replace(
				/(\{|,)\s*([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g,
				'$1"$2":'
			);
			
			return JSON.parse(fixedJson);
		} catch (innerError) {
			// If both attempts fail, throw the original error
			throw e;
		}
	}
}
